<template>
  <div class="detail-box">
    <el-form ref="form" :model="form" :rules="rules" label-width="160px" class="form-box">
      <div class="title">基本信息</div>
      <el-form-item label="权益卡名称：" prop="cardName">
        <el-input v-model="form.cardName" maxlength="50" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="默认时长：" prop="defaultDurationDays">
        <el-input-number v-model="form.defaultDurationDays" :min="1" :max="36500" />
        <span style="margin-left: 8px">天</span>
      </el-form-item>
      <el-form-item label="卡号前缀：">
        <el-input v-model="form.cardPrefix" maxlength="4" clearable placeholder="默认 RC，2~4 位字母" style="width: 160px" />
      </el-form-item>
      <el-form-item label="是否在列表展示：" prop="showInList">
        <el-switch v-model="form.showInList" :active-value="1" :inactive-value="0" />
      </el-form-item>

      <div class="title">本人服务</div>
      <div v-for="(sid, idx) in form.selfItemIds" :key="'s' + idx" class="service-row">
        <el-select v-model="form.selfItemIds[idx]" filterable clearable placeholder="请选择" style="width: 360px">
          <el-option v-for="el in itemOptions" :key="el.id" :label="el.itemName" :value="el.id" />
        </el-select>
        <el-button type="text" icon="el-icon-delete" @click="form.selfItemIds.splice(idx, 1)" />
      </div>
      <el-button type="text" @click="form.selfItemIds.push(null)">+ 添加服务</el-button>

      <div class="title">家属服务</div>
      <el-form-item label="绑定方式：">
        <el-radio-group v-model="form.familyBindMode">
          <el-radio :label="0">仅限权益人绑定</el-radio>
          <el-radio :label="1">权益人及家属绑定</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否允许解绑：">
        <el-radio-group v-model="form.familyUnbindAllowed">
          <el-radio :label="0">不允许</el-radio>
          <el-radio :label="1">允许</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="家属上限个数：" prop="familyMaxCount">
        <el-input-number v-model="form.familyMaxCount" :min="0" :max="99" />
      </el-form-item>
      <div v-for="(fid, idx) in form.familyItemIds" :key="'f' + idx" class="service-row">
        <el-select v-model="form.familyItemIds[idx]" filterable clearable placeholder="请选择" style="width: 360px">
          <el-option v-for="el in itemOptions" :key="el.id" :label="el.itemName" :value="el.id" />
        </el-select>
        <el-button type="text" icon="el-icon-delete" @click="form.familyItemIds.splice(idx, 1)" />
      </div>
      <el-button type="text" @click="form.familyItemIds.push(null)">+ 添加服务</el-button>

      <div class="btns">
        <el-button type="primary" :loading="saving" @click="submit">{{ isEdit ? "保存" : "新增" }}</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "rightsCardDetail",
  data() {
    return {
      saving: false,
      itemOptions: [],
      form: {
        cardName: "",
        defaultDurationDays: 365,
        cardPrefix: "RC",
        showInList: 1,
        familyBindMode: 0,
        familyUnbindAllowed: 0,
        familyMaxCount: 0,
        selfItemIds: [null],
        familyItemIds: [],
      },
      rules: {
        cardName: [{ required: true, message: "请输入权益卡名称", trigger: "blur" }],
        defaultDurationDays: [{ required: true, message: "请输入默认时长", trigger: "change" }],
        showInList: [{ required: true, message: "请选择", trigger: "change" }],
        familyMaxCount: [{ required: true, message: "请输入家属上限", trigger: "change" }],
      },
    };
  },
  computed: {
    isEdit() {
      return this.$route.name === "rightsCardEdit";
    },
  },
  created() {
    this.loadItemOptions();
    if (this.isEdit && this.$route.query.id) {
      this.loadDetail(this.$route.query.id);
    }
  },
  methods: {
    async loadItemOptions() {
      const res = await this.axios.get(this.getApiUrl("rightsCardItemOptions"));
      this.itemOptions = res.data || [];
    },
    async loadDetail(id) {
      const res = await this.axios.get(this.getApiUrl("rightsCardView"), { params: { id } });
      const d = res.data || {};
      this.form = {
        id: d.id,
        cardName: d.cardName,
        defaultDurationDays: d.defaultDurationDays,
        cardPrefix: d.cardPrefix || "RC",
        showInList: d.showInList == null ? 1 : d.showInList,
        familyBindMode: d.familyBindMode == null ? 0 : d.familyBindMode,
        familyUnbindAllowed: d.familyUnbindAllowed == null ? 0 : d.familyUnbindAllowed,
        familyMaxCount: d.familyMaxCount == null ? 0 : d.familyMaxCount,
        selfItemIds: d.selfItemIds && d.selfItemIds.length ? d.selfItemIds : [null],
        familyItemIds: d.familyItemIds || [],
      };
    },
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        const payload = {
          ...this.form,
          selfItemIds: (this.form.selfItemIds || []).filter((x) => x != null),
          familyItemIds: (this.form.familyItemIds || []).filter((x) => x != null),
        };
        this.saving = true;
        try {
          const api = this.isEdit ? "rightsCardEdit" : "rightsCardCreate";
          const res = await this.axios.post(this.getApiUrl(api), payload, {
            toJSON: true,
          });
          if (res && res.code === 1) {
            this.$message.success("操作成功");
            this.$router.push({ name: "rightsCard" });
          } else {
            this.$message.error((res && res.msg) || "操作失败");
          }
        } finally {
          this.saving = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.detail-box {
  padding: 20px 24px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 12px;
}
.service-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-left: 160px;
}
.btns {
  margin-top: 24px;
  margin-left: 160px;
}
.form-box {
  max-width: 800px;
}
</style>
